<template>
	<div class="page-overlay">
		<div id="login_wrapper">
            <div id="overlayWhenLoggingIn" v-if="loggingIn">
            </div>
            <div id="closeLogin" @click="close">
                X
            </div>
			<div id="loginFormTitle">
                Login To McCluskey Wholesale
            </div>
			<form id='loginFormDiv'>
				<div class="loginFormItem">
					<label for="username" class="loginFormItemTitle">
                        Username
                    </label>
					<input type="text" id="username" name="username" v-model="username" @focus="keyboardOpen()" @blur="keyboardClose()">
				</div>
				
				<div class="loginFormItem">
					<label for="password" class="loginFormItemTitle">
                        Password
                    </label>
					<input id="password" type="password" name="password" v-model="password" @focus="keyboardOpen()" @blur="keyboardClose()">
				</div>

				<div v-show="hasLoginError != ''" class="error-message">
					{{ hasLoginError }}
				</div>
			</form>
            <div id="loginFormSubmit" @click="login">
                Login
            </div>
			<div id="login_loader" :class="[loggingIn ? 'appear' : '']">
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        data () {
            return {
                username: "",
                password: ""
            }
        },
        computed: {
			loggingIn() {
				return this.$store.getters.isLoggingIn;
            },
            hasLoginError() {
                return this.$store.getters.getLoginErrorMsg;
            },
            softKeyboard() {
                return (!this.$store.getters.isMobile && this.$store.getters.isMobileKeyboardOpen);
            }
        },
        methods: {
            close() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('close_form', {'event_category': 'authentication','event_label': eventLabel});
                this.$store.commit('updateLoginFormVisible', false); 
                this.$store.commit('updateLoginErrorMsg', "");
                this.$router.push({path: '/', query: this.$router.query});
            },
            login () {
                if(!this.loggingIn) {
                    let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                    this.$gtag.event('submit_login', {'event_category': 'authentication','event_label': eventLabel});
                    this.$store.dispatch('authenticateUser', {email: this.username, password: this.password});
                }
            },
            keyboardOpen() {
                this.$store.commit('updateMobileKeyboradStatus', true); 
            },
            keyboardClose() {
                this.$store.commit('updateMobileKeyboradStatus', false); 
            }
        }
    }
</script>

<style>
    #closeLogin {
        position: absolute;
        top: calc((1 * var(--vh)) + (1 * var(--vw)));
        right: calc((1 * var(--vh)) + (1 * var(--vw)));
    }

    .inmobile #closeLogin {
        top: calc(2 * var(--vh));
    }

    #closeLogin:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
        cursor: pointer;
    }

    .error-message {
        color: red;
        text-align: center;
    }
    
    .page-overlay {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10;
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        background-color: rgba(0,0,0,0.8);
    }
    
    #login_wrapper {
        position: fixed;
        top: calc(2 * var(--vh));
        left: calc(35 * var(--vw));
        width: calc(30 * var(--vw));
        height: calc(40 * var(--vh));
        padding: calc(2 * var(--vh)) calc(2 * var(--vw));
        background-color: #ececec;
        border-radius: calc(var(--vratio) * 2 * var(--vh));
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .inmobile #login_wrapper {
        width: calc(94 * var(--vw));
        height: calc(94 * var(--vh));
        top: calc(1 * var(--vh));
        left: calc(1 * var(--vw));
        justify-content: center;
        border-radius: 5px;
    }

    #loginFormTitle {
        font-size: calc((1.5 * var(--vw)) + ((var(--vratio) - .5) * 1em));
        text-align: center;
        margin: calc(2 * var(--vh)) 0;
    }

    .inmobile #loginFormTitle {
        margin: calc(4 * var(--vh)) 0;
		font-size: calc(2.4 * var(--vh));
    }

    #loginFormDiv {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin: calc(2 * var(--vh));
        width: calc(20 * var(--vw));
    }

    .inmobile #loginFormDiv {
        width: calc(80 * var(--vw));
    }
    
    .loginFormItem {
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em));
        display: flex;
        width: 100%;
        margin-bottom: calc(1 * var(--vh));
        justify-content: space-between;
        align-items: center;
    }

    .inmobile .loginFormItem {
		font-size: calc(2.1 * var(--vh))
    }

    .loginFormItem > input {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        width: 66%;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em));
    }

    .inmobile .loginFormItem > input {
		font-size: calc(2.1 * var(--vh))
    }

    .loginFormItemTitle {
        margin-right: calc(.5 * var(--vw));
        width: 34%;
    }

    #loginFormSubmit {
        background-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
        border-radius: calc(var(--vratio) * var(--vh));
        width: calc(8.5 * var(--vw));
        height: calc(1.8 * var(--vw));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bold;
        color: white;
    }

    .inmobile #loginFormSubmit {
        width: calc(14* var(--vh));
        height: calc(4 * var(--vh));
        padding: calc(.2 * var(--vw)) 0;
        border-radius: 5px;
    }

    #overlayWhenLoggingIn {
        position: absolute;
        width: calc(34 * var(--vw));
        height: calc((40 * var(--vh)) + (4 * var(--vw)));
        padding: calc(2 * var(--vh)) calc(2 * var(--vw));
        background-color: black;
        opacity: .4;
        z-index: 1
    }

    #login_loader {
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 2;
        margin: -15px 0 0 -15px;
        border: 6px solid rgb(172,179,183);
        border-radius: 50%;
        border-top: 6px solid #207BD3;
        width: 18px;
        height: 18px;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    #login_loader.appear {
        opacity: 1;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>